//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
import moment from 'moment';
export default {
  name: 'MeasurementTable',
  components: {
    DataTable: DataTable
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Date'),
        columnId: 'datetime',
        type: 'datetime',
        show: true,
        default: function _default() {
          return moment().format('YYYY-MM-DDTHH:mm');
        }
      }, {
        name: t('health', 'Temperature'),
        columnId: 'temperature',
        type: 'number',
        show: this.person.measurementColumnTemperature,
        min: 35,
        max: 42
      }, {
        name: t('health', 'Heart rate'),
        columnId: 'heartRate',
        type: 'number',
        show: this.person.measurementColumnHeartRate,
        min: 0
      }, {
        name: t('health', 'Blood pressure systolic'),
        columnId: 'bloodPressureS',
        type: 'number',
        show: this.person.measurementColumnBloodPres,
        min: 0
      }, {
        name: t('health', 'Blood pressure diastolic'),
        columnId: 'bloodPressureD',
        type: 'number',
        show: this.person.measurementColumnBloodPres,
        min: 0
      }, {
        name: t('health', 'Oxygen saturation'),
        columnId: 'oxygenSat',
        type: 'number',
        show: this.person.measurementColumnOxygenSat,
        min: 80,
        max: 100,
        // unter 90 ist dramatisch
        style: function style(value) {
          if (value < 90) {
            return 'color: darkred; font-weight: bolder;';
          } else {
            return '';
          }
        }
      }, {
        name: t('health', 'Blood sugar'),
        columnId: 'bloodSugar',
        type: 'number',
        show: this.person.measurementColumnBloodSugar,
        min: 40,
        max: 600,
        // 80-120 ist normal
        style: function style(value) {
          if (value < 80 || value > 120) {
            return 'color: darkred; font-weight: bolder;';
          } else {
            return '';
          }
        }
      }, {
        name: t('health', 'Defecation'),
        columnId: 'defecation',
        type: 'select',
        show: this.person.measurementColumnDefecation,
        options: [{
          id: 0,
          label: t('health', 'low', {})
        }, {
          id: 1,
          label: t('health', 'middle', {})
        }, {
          id: 2,
          label: t('health', 'high', {})
        }, {
          id: 3,
          label: t('health', 'extreme', {})
        }],
        style: function style(value) {
          if (value === 3) {
            return 'color: darkred; font-weight: bolder;';
          } else {
            return '';
          }
        }
      }, {
        name: t('health', 'Appetite'),
        columnId: 'appetite',
        type: 'select',
        show: this.person.measurementColumnAppetite,
        options: [{
          id: 0,
          label: t('health', 'low', {})
        }, {
          id: 1,
          label: t('health', 'middle', {})
        }, {
          id: 2,
          label: t('health', 'high', {})
        }, {
          id: 3,
          label: t('health', 'extreme', {})
        }],
        style: function style(value) {
          if (value === 3) {
            return 'color: darkred; font-weight: bolder;';
          } else {
            return '';
          }
        }
      }, {
        name: t('health', 'Allergies'),
        columnId: 'allergies',
        type: 'select',
        show: this.person.measurementColumnAllergies,
        options: [{
          id: 0,
          label: t('health', 'low', {})
        }, {
          id: 1,
          label: t('health', 'middle', {})
        }, {
          id: 2,
          label: t('health', 'high', {})
        }, {
          id: 3,
          label: t('health', 'extreme', {})
        }],
        style: function style(value) {
          if (value === 3) {
            return 'color: darkred; font-weight: bolder;';
          } else {
            return '';
          }
        }
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true,
        placeholder: t('health', 'Give some comment, if you want...', {}),
        maxlength: 1000
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('measurementDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      // console.debug('update item', item)
      this.$store.dispatch('measurementDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('measurementDatasetsDelete', item);
    }
  }
};